<form *transloco="let t" class="my-4 flex flex-col gap-2" [formGroup]="form">
  <h3 tuiTitle="m">{{ t('Sélectionner les séquences à ajouter au télésuivi') }}</h3>
  @let hasSequences = $safeNavigationMigration(form.get('sequences').value?.length) > 0;
  <pxc-sequence-picker-input
    class="w-full gap-3"
    data-testid="sequence-picker"
    formControlName="sequences"
    ngDefaultControl
    [buttonLabel]="hasSequences ? t('Modifier la sélection') : t('Ajouter des séquences')"
    [clientCode]="clientCode"
    [departmentIds]="departmentIds"
    [dialogSaveLabel]="t('Ajouter')"
    [dialogTitle]="t('Sélectionner les séquences à ajouter au télésuivi')"
    [editOnMediaClick]="true"
    [patientId]="patientId">
    <span emptyState>
      {{ t('Cette étape est facultative, vous pourrez ajouter des séquences à ce télésuivi plus tard.') }}
    </span>
  </pxc-sequence-picker-input>
  <tui-error formControlName="sequences" />
</form>
